import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useStyleConfig, Box } from '@chakra-ui/react';
import { Draggable as Draggable$1 } from 'react-beautiful-dnd';
import { Typography } from '../Typography/component.js';
var Draggable = function Draggable(_ref) {
  var draggable = _ref.draggable,
    draggableIndex = _ref.draggableIndex,
    children = _ref.children,
    textStyle = _ref.textStyle;
  var styles = useStyleConfig('DragAndDrop');
  return /*#__PURE__*/React.createElement(Draggable$1, {
    draggableId: draggable.id.toString(),
    index: draggableIndex
  }, function (provided) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      __css: styles
    }, provided.draggableProps, provided.dragHandleProps, {
      ref: provided.innerRef
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: textStyle
    }, draggable.description), children(provided));
  });
};
Draggable.displayName = "Draggable";
export { Draggable };